import * as React from "react";
import { DEFAULT_API_HOSTNAME } from "./api/config.js";
import type { Elements } from "./elements.js";

export interface WidgetsContextType {
  elements: Elements;
  apiBaseUrl: string;
}

const WidgetsContext = React.createContext<WidgetsContextType | undefined>(
  undefined,
);
WidgetsContext.displayName = "WidgetsContext";
export { WidgetsContext };

export function useWorkOsApiUrl() {
  const context = React.useContext(WidgetsContext);
  return context?.apiBaseUrl || `https://${DEFAULT_API_HOSTNAME}`;
}

export function useElement<K extends keyof Elements>(
  key: K,
): NonNullable<Elements[K]> {
  const context = React.useContext(WidgetsContext);
  if (!context) {
    throw new Error("useElement must be used within a WidgetsContext provider");
  }
  return context.elements[key] || {};
}
